import { Component, ChangeDetectionStrategy, Output, EventEmitter, Input, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged, map } from "rxjs/operators";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
	selector: "bp-search-bar",
	templateUrl: "./bp-search-bar.component.html",
	styleUrls: ["./bp-search-bar.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class BpSearchBarComponent implements OnInit {
	public currentSearchValue: string;
	private searchValueKeyup$: Subject<string> = new Subject<string>();

	@Input()
	public placeholder: string = "";

	@Input()
	public initialSearchValue: string = "";

	@Input()
	public debounceTime: number = 300;

	@Output()
	public searchValueChange: EventEmitter<string> = new EventEmitter<string>();

	public ngOnInit(): void {
		this.currentSearchValue = this.initialSearchValue;
		this.searchValueKeyup$
			.pipe(
				untilDestroyed(this),
				debounceTime(this.debounceTime),
				distinctUntilChanged(),
				map((searchValue: string) => searchValue?.trim())
			)
			.subscribe((searchValue: string) => {
				this.searchValueChange.emit(searchValue);
			});
	}

	public onSearchKeyUp(searchValue: string): void {
		this.searchValueKeyup$.next(searchValue);
	}
}
